:host {
  --textarea-action-buttons-width: 100px;
  --textarea-max-width: 800px;
}

.wrapper {
  background-color: var(--white-layout-302-level-1-elevation);

  .content {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .chat-container {
      overflow: auto;
      flex: 1;
      width: 100%;
      padding: calc(var(--spacer) * 4) 0;
      position: relative;

      & > * {
        max-width: 880px;
        margin: auto;
      }
      gz-chat-card {
        padding: calc(var(--spacer) * 1) calc(var(--spacer) * 5);
      }
      gz-chat-incident-update {
        padding: calc(var(--spacer) * 1) 0;
        height: fit-content;
      }
      gz-chat-notice {
        padding: calc(var(--spacer) * 1) calc(var(--spacer) * 5);
        height: fit-content;
      }
      gz-info-box {
        --info-box-width: 100%;
        --info-box-max-width: 880px;
      }
    }

    .footer {
      padding: calc(var(--spacer) * 1.5) calc(var(--spacer) * 5);
      height: 112px;
      background-color: var(--white-layout-302-level-1-elevation);
      width: 100%;
      box-shadow: 0 -5px 5px -5px var(--chart-101-pressed-dividers);
      position: relative;
      display: flex;
      justify-content: space-between;

      .hidden-card {
        visibility: hidden;
      }
    }
  }

  .empty-state,
  .unavailable-state,
  .error-state {
    display: none;

    .image-repo-title {
      margin-bottom: calc(var(--spacer) - 2px);
    }

    .image-repo-title,
    .image-repo-text {
      color: var(--main-titles-inputs-600);
    }
  }

  &.is-error,
  &.is-unavailable {
    .content {
      display: none;
    }
  }
  &.is-empty .empty-state,
  &.is-error .error-state,
  &.is-unavailable .unavailable-state {
    display: block;
  }
}

gz-textarea-with-suggestions {
  padding-left: var(--textarea-action-buttons-width);
  width: 100%;
  max-width: calc(2 * var(--textarea-action-buttons-width) + var(--textarea-max-width));
}
